import script from "./concept.vue?vue&type=script&setup=true&lang=js"
export * from "./concept.vue?vue&type=script&setup=true&lang=js"

import "./concept.vue?vue&type=style&index=0&id=feda0894&lang=less"
import "./concept.vue?vue&type=style&index=1&id=feda0894&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feda0894"]])

export default __exports__